import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {},
	// `Page` supplies horizontal padding only, so the top gap is the page's own — same as the other
	// integration pages that lead with a heading rather than a logo.
	header: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		marginBottom: THEME.spacing.xl,
		marginTop: THEME.spacing.xl,
		maxWidth: 800,
	},
	center: {
		display: 'flex',
		gap: THEME.spacing.sm,
		justifyContent: 'center',
		marginTop: THEME.spacing.md,
	},
	removeLink: {
		color: THEME.colors.danger.main,
		':active': {
			color: THEME.colors.danger.dark,
		},
		':focus': {
			color: THEME.colors.danger.dark,
		},
		':hover': {
			color: THEME.colors.danger.dark,
		},
	},
	signInContainer: {
		borderRadius: THEME.common.borderRadius,
		minHeight: 0,
		padding: THEME.spacing.md,
	},
	savedState: {
		alignItems: 'center',
		color: THEME.colors.text.light,
		display: 'flex',
		fontSize: THEME.typography.fontSizes.xs,
		gap: THEME.spacing.xs,
		marginTop: THEME.spacing.xs,
	},
	hint: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
	},
});
